import { ChangeEvent, useCallback, useEffect, useMemo, useState } from "react";
import useUiuxStore from "../../store/useUiuxStore"
import ModalWrapper from "../common/modal/ModalWrapper"
import { InputForm } from "../common/form copy/input/InputForm";
import { changePassword, findId } from "../../apis/authApi";
import { formatPhoneNumber } from "../../utils/string/stringUtil";

export const FindAccountModal = () => {

    const { setFindAccountModalVisible } = useUiuxStore();


    /**
     * 예시
     * 123(송치영)
     * 751228
     * 주민뒷번호 테스트불가
     * 010-4815-7989
     */
    const [inputData, setInputData] = useState({
        userName: '',
        rrnFront: '',
        rrnBack: '',
        phoneNumber: '',
        newPassword: '',
        newPasswordCheck: ''
    });

    const [userId, setUserId] = useState('');

    const handleFindIdClick = useCallback(async () => {
        const { userName, rrnFront, rrnBack, phoneNumber } = inputData;

        if (userName === '' || rrnFront === '' || rrnBack === '' || phoneNumber === '') {
            alert('아이디 찾기 입력란을 채워주세요.');
            return;
        }

        const response = (await findId(userName, rrnFront, rrnBack, phoneNumber));
        if (response && response.data && response.data.successFlag) {
            setUserId(response.data.data);
        }
    }, [inputData])

    const handleChangePasswordClick = useCallback(async () => {
        const { userName, rrnFront, rrnBack, phoneNumber, newPassword, newPasswordCheck } = inputData;

        if (userId.trim() === '') {
            alert('아이디를 먼저 찾아주세요');
            return;
        }
        if (newPassword !== newPasswordCheck) {
            alert('비밀번호를 확인해주세요.');
            return;
        }

        const response = await changePassword(userName, rrnFront, rrnBack, phoneNumber, userId, newPassword);
        if (response.data.successFlag) {
            alert('비밀번호가 성공적으로 변경되었습니다.');
            setFindAccountModalVisible(false);
        }
    }, [inputData, userId])

    const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.currentTarget;

        if (name === 'phoneNumber') {
            setInputData({
                ...inputData,
                phoneNumber: formatPhoneNumber(value)
            })
        } else {
            setInputData({
                ...inputData,
                [name]: value
            })
        }
    }, [inputData])

    return <ModalWrapper size="md" overlay={true} width={40}
        onOverlayClick={() => setFindAccountModalVisible(false)} onEscKeyDown={() => setFindAccountModalVisible(false)}>
        <div className="w-full h-[10%] flex items-center px-[24px] bg-gray-100">
            아이디 / 비밀번호 찾기
        </div>
        <div className="w-full h-[80%] py-[12px] px-[24px] flex flex-col gap-[16px]">
            <p>아이디 찾기</p>
            <InputForm title="이름" value={inputData.userName} editable={true} name="userName" onChange={handleChange} />
            <div className="flex gap-[8px]">
                <InputForm title="주민등록번호" value={inputData.rrnFront} editable={true} name="rrnFront" onChange={handleChange} maxLength={6} />
                <InputForm value={inputData.rrnBack} editable={true} name="rrnBack" onChange={handleChange} type="password" maxLength={7} />
            </div>
            <InputForm title="휴대폰 번호" value={inputData.phoneNumber} editable={true} name="phoneNumber" onChange={handleChange} />
            <button className={`w-[140px] text-white rounded-[4px] bg-blue-dark px-[16px] font-semibold self-end`}
                onClick={handleFindIdClick}>
                찾기
            </button>
            <p>비밀번호 변경</p>
            <InputForm title="아이디" value={userId} editable={false} />
            <InputForm title="비밀번호" value={inputData.newPassword} editable={true} name="newPassword" onChange={handleChange} type="password" />
            <InputForm title="비밀번호 확인" value={inputData.newPasswordCheck} editable={true} name="newPasswordCheck" onChange={handleChange} type="password" />
            <button className={`w-[140px] text-white rounded-[4px] bg-blue-dark px-[16px] font-semibold self-end`}
                onClick={handleChangePasswordClick}>
                비밀번호 변경
            </button>
        </div>
        <div className="w-full h-[10%] flex justify-end items-center gap-[8px] px-[24px]">
            <button className={`w-[140px] text-white rounded-[4px] bg-red-500 px-[16px] font-semibold`}
                onClick={() => setFindAccountModalVisible(false)}>
                닫기
            </button>
        </div>
    </ModalWrapper>
}